import type { SiteLocale } from '@/lib/marketing/page-metadata';

export const INDUSTRY_SLUGS = ['hotels', 'construction', 'manufacturing', 'mining', 'field-teams'] as const;

export type IndustrySlug = (typeof INDUSTRY_SLUGS)[number];

export interface Faq {
  question: string;
  answer: string;
}

export interface IndustryContent {
  name: string;
  blurb: string;
  audience: string;
  title: string;
  description: string;
  h1: string;
  intro: string;
  scenario: { heading: string; paragraphs: string[] };
  reach: { heading: string; intro: string };
  sample: {
    heading: string;
    intro: string;
    channel: string;
    questions: string[];
    spoken?: { label: string; quote: string };
    reportLine: string;
  };
  faqs: Faq[];
  og: { title: string; subtitle: string };
}

export interface LocaleUi {
  languageName: string;
  scenarioLabel: string;
  reachLabel: string;
  reachPoints: { title: string; body: string }[];
  sampleLabel: string;
  sampleExample: string;
  sampleQuestionsLabel: string;
  sampleReportLabel: string;
  sampleLink: string;
  reportLabel: string;
  reportHeading: string;
  reportPoints: string[];
  setupLine: string;
  faqLabel: string;
  faqHeading: string;
  heroTrust: string;
  closerHeading: string;
  closerBody: string;
  closerTrust: string[];
  startCta: string;
  contactCta: { label: string; subject: string };
  industriesLabel: string;
  industriesHeading: string;
  footerIndustries: string;
  footerLanguage: string;
  footerTagline: string;
  footerProduct: string;
  footerSolutions: string;
  footerCompany: string;
  footerRights: string;
  footerLinks: {
    startRoutine: string;
    bookingPages: string;
    guides: string;
    pricing: string;
    studio: string;
    founders: string;
    engineering: string;
    about: string;
    trust: string;
    privacy: string;
    terms: string;
  };
  /** Shown to a reader of THIS language on a page in another one. */
  suggestion: { prompt: string; action: string; dismiss: string };
}

export interface LocalizedHomeContent {
  title: string;
  description: string;
  label: string;
  h1: string;
  intro: string;
  entity: string;
  markets: string;
  stepsLabel: string;
  stepsHeading: string;
  steps: { title: string; body: string }[];
  pricing: { label: string; heading: string; body: string; link: string };
  og: { title: string; subtitle: string };
}

export interface LocaleContent {
  locale: SiteLocale;
  ui: LocaleUi;
  home?: LocalizedHomeContent;
  industries: Record<IndustrySlug, IndustryContent>;
}
